import { useQuery, gql } from '@apollo/client';
import { Categories, CategoryInput } from '~types';

import { GET_CASE } from './index';

interface GetCategoriesData {
  getCategories: Categories;
}

export const GET_CASES_CATEGORIES = gql`
  query useGetCategories($input: CategoryInput!) {
    getCategories(input: $input) {
      count
      getCategories {
        id
        isSmall
        getName
        getDescription
        color
        getCases {
          ...CaseFields
        }
      }
    }
  }

  ${GET_CASE.fragments.getCase}
`;

//TO DO: оптимизация в том числе и оптимизация для категорий на главной
//Передавать нужно кол-во/сделать хук чтобы тянуть только одну категорию и тд
export default (where = {}, isRecomended = false) => {
  //console.log('isRecomended11111', isRecomended);
  return useQuery<GetCategoriesData, { input: CategoryInput }>(
    GET_CASES_CATEGORIES,
    {
      variables: {
        input: {
          offset: 0,
          limit: 15,
          where,
          categoryName: isRecomended ? 'Recommended' : null,
        },
      },
    },
  );
};
